import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { ExitIcon } from 'assets/materialIcons/materialIcons';
import { authLogout } from 'store/actions/auth/authLogout';
import { closeModal, modalStartLoading, openConfirmModal } from 'store/actions/modalActions';
import { connect } from 'react-redux';

class LogoutMenuItem extends React.Component {
    handleClick = () => {
        const {
            dispatchCloseModal,
            dispatchOpen,
            dispatchRequest,
            dispatchStartLoader,
            history,
            translate,
        } = this.props;

        dispatchOpen({
            actions: {
                submit: () => {
                    dispatchStartLoader();

                    const payload = {
                        onSuccess: () => {
                            dispatchCloseModal();

                            authHelper.clearSession();

                            history.push('/login');
                        },
                    };

                    setTimeout(() => {
                        dispatchRequest(payload);
                    }, 500);
                },
            },
            content: {
                description: translate('auth.logout.description'),
            },
            title: translate('auth.logout.title'),
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        return <MenuItem
            leftIcon={ <ExitIcon /> }
            onClick={ () => {
                return this.handleClick();
            } }
            primaryText={ translate('auth.logout.title') }
        />;
    }
}

LogoutMenuItem.propTypes = {
    dispatchCloseModal: PropTypes.func.isRequired,
    dispatchOpen: PropTypes.func.isRequired,
    dispatchRequest: PropTypes.func.isRequired,
    dispatchStartLoader: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchOpen: (payload) => {
            dispatch(openConfirmModal(payload));
        },
        dispatchRequest: (payload) => {
            dispatch(authLogout(payload));
        },
        dispatchStartLoader: () => {
            dispatch(modalStartLoading());
        },
        dispatchCloseModal: () => {
            dispatch(closeModal());
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
);

export default enhance(LogoutMenuItem);



// WEBPACK FOOTER //
// ./src/components/layout/Layout/header/userMenu/LogoutMenuItem.js